import { useServerData, LIST_MIN_LOADING_MS } from '@/hooks/useServerData';
import { AgencyDashboardService } from '@/services/agencyDashboard.service';
import {
  AgencyAdvisorMemberRow,
  AgencyDashboardPeriod,
} from '@/integrations/supabase/rpc-types';

/**
 * Il periodo è controllato dal componente padre (condiviso con la tab Panoramica).
 *
 * `enabled` esiste per il filtro Travel Advisor della tab Clienti, che monta anche per
 * travel_designer e travel_advisor_member: la RPC risponde loro con un'eccezione, e senza
 * un modo per non chiamarla ogni advisor si prenderebbe un toast di errore all'apertura
 * della tab. Disattivato, restituisce una lista vuota.
 */
export function useAgencyAdvisorMembers(
  period: AgencyDashboardPeriod,
  enabled = true,
  refreshKey = 0
) {
  return useServerData<AgencyAdvisorMemberRow[]>(
    JSON.stringify({ period, refreshKey }),
    [],
    () => AgencyDashboardService.getAdvisorMembers(period),
    enabled,
    LIST_MIN_LOADING_MS
  );
}

export default useAgencyAdvisorMembers;
